import { render } from "./App.vue?vue&type=template&id=54ab1e32&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=54ab1e32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ab1e32"]])

export default __exports__